
import {
  useData,
  DataProvider,
  DataSDKError,
  getDataSession,
  getConfig,
  initSDK,
  validateConfig,
  isPreviewMode
} from '@happyspace/sdk';

export function getSiteConfig() {
  const config = getConfig();
  const sc = (typeof window !== 'undefined' && window.SITE_CONFIG) || {};
  return {
    businessId: config.businessId || sc.businessId || '',
    apiBaseUrl: config.apiBaseUrl || sc.apiBaseUrl || 'https://api.happyspace.one/api/v1',
    stripePublishableKey: sc.stripePublishableKey || '',
    taxRate: typeof sc.taxRate === 'number' ? sc.taxRate : 0.08
  };
}

export {
  useData,
  DataProvider,
  DataSDKError,
  getDataSession,
  initSDK,
  getConfig,
  validateConfig,
  isPreviewMode
};
